import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { RequestService } from '@core';
import { HomePage } from 'app/models/home-page';
import { CommonService } from 'app/service/common.service';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent {

 home:HomePage=new HomePage();
 links:any;
  constructor(private requestService: RequestService, public commonService: CommonService, private router : Router) {  }


  doLogin() {
    window.open(this.requestService.getCompleteUrlByEndPoint('private/auth'), "_self");
  }


}
